import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringLegislationLibrary = api(async function getAuthoringLegislationLibrary() {
    return query(
        gql`
            query GetAuthoringLegislationLibrary {
                getAuthoringLegislationLibrary
            }
        `,
        {},
        { returns: "getAuthoringLegislationLibrary" }
    )
})
